import { render, staticRenderFns } from "./FormationStatusDrawer.vue?vue&type=template&id=93a37132&scoped=true&"
import script from "./FormationStatusDrawer.vue?vue&type=script&lang=ts&"
export * from "./FormationStatusDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./FormationStatusDrawer.vue?vue&type=style&index=0&id=93a37132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a37132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VBtn,VDivider,VIcon,VNavigationDrawer,VSimpleTable,VSkeletonLoader,VSpacer,VToolbar,VToolbarTitle})
